import { useMutation, useQueryClient } from "@tanstack/react-query";
import { TwilioService } from "@/services/communication/TwilioService";
import { Agent } from "@/types/agent/agent";
import { ListenerPhoneSettings } from "@/types/phone/listener";

export const useListenerPhoneSettings = (agent: Agent) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (params: { phoneNumberId: string; settings: Partial<ListenerPhoneSettings> }) =>
      TwilioService.updateListenerPhoneSettings(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["phoneNumber", agent.id] });
      queryClient.invalidateQueries({ queryKey: ["agent"] });
      queryClient.invalidateQueries({ queryKey: ["agents"] });
      queryClient.invalidateQueries({ queryKey: ["user-agents"] });
      queryClient.invalidateQueries({ queryKey: ["all-agents", agent.id] });
    },
  });

  return {
    saveSettings: mutation.mutateAsync,
    isSaving: mutation.isPending,
  };
};
